<template>
    <li class="input-task m-y-10">
        <div class="input-task-wrapper">
            <textarea
                :disabled="disabled"
                placeholder="..."
                ref="textarea"
                v-model="text"
                :maxlength="maxLength"
                class="input-task-textarea font text-base l-h-20 f-w-500"
                @keyup.enter="add"
                @keyup.backspace="add"
            />
        </div>
    </li>
</template>

<script>
export default {
    props: {
        autofocus: {
            type: Boolean,
            default: false,
        },
        heightPerLine: {
            type: Number,
            default: 28,
        },
        perLine: {
            type: Number,
            default: 80,
        },
        value: {
            type: String,
            default: '',
        },
        maxLength: {
            type: [Number, String],
            default: 100,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    data() {
        const { value } = this;
        return {
            text: value || '',
            scrollHeight: 28,
        };
    },
    computed: {
        counter() {
            return 1;
        },
    },
    watch: {
        text(text) {
            if (this.value === text) return;

            this.autoResize();
            this.scrollHeight = this.$refs.textarea.scrollHeight;
            this.$emit('input', text.replace(/\n/g, ''));
        },
        scrollHeight(scrollHeight) {
            this.$refs.textarea.style.height = `${Math.ceil(scrollHeight / this.heightPerLine) * this.heightPerLine}px`;
        },
        value(value) {
            this.text = value;
        },
    },
    mounted() {
        // this.$refs.textarea.focus();
    },
    methods: {
        autoResize() {
            this.$refs.textarea.style.height = 'auto';
            const { perLine } = this;
            const h = (Math.ceil(this.text.length / perLine) * this.heightPerLine) || this.heightPerLine;
            this.$refs.textarea.style.height = `${h}px`;
        },
        add(e) {
            this.text = this.text.replace(/\n/g, '');

            if (e.key === 'Backspace' || e.key === 'Delete') {
                console.log(this.text.length);
                if (!this.text.length) {
                    this.$emit('remove', this.index);
                }

                e.preventDefault(); // Don't do anything to the input value
                return;
            }

            this.autoResize();
            this.$emit('add');
        },
    },
};
</script>

<style lang="scss" scoped>
    .input-task {
        list-style: decimal-leading-zero;
        width: 100%;

        .input-task-wrapper {
            display: flex;
            width: inherit;

            .input-task-textarea {
                width: inherit;
                height: 28px;
                resize: none;
                border: none;
                background-color: transparent;

                &:focus {
                    outline: none;
                    border: none;
                }
            }
        }
    }
</style>
